<template>
  <div class="mypage-ticket-today-table-parts">
    <div
      v-for="(ticket, index) in ticketList"
      :key="index"
      class="mypage-ticket-today-table-parts__item"
    >
      <p class="mypage-ticket-today-table-parts__item-name">{{ ticket.ticketName }}</p>
      <p class="mypage-ticket-today-table-parts__item-count">
        ×{{ getTicketTotalCountByTicket(ticket, ownOrganization) }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import DigitalTicketDataTicketDocument from '@/store/stores/collectionModule/documents/digitalTicket/DigitalTicketDataTicketDocument'
import OrganizationDocument from '@/store/stores/collectionModule/documents/organization/OrganizationDocument'
import usePurchasedTicketData from '@/components/hook/ticket/usePurchasedTicketData'

export default defineComponent({
  name: 'MypageTicketTodayTableParts',
  props: {
    /**
     * デジタルチケット チケット情報
     */
    ticketList: {
      type: Array as PropType<Array<DigitalTicketDataTicketDocument>>,
      default: () => [],
    },
    /**
     * ログインユーザーの組織情報
     */
    ownOrganization: {
      type: Object as PropType<OrganizationDocument>,
      default: () => ({}),
    },
  },
  setup() {
    const { getTicketTotalCountByTicket } = usePurchasedTicketData()

    return {
      getTicketTotalCountByTicket,
    }
  },
})
</script>

<style scoped lang="scss">
.mypage-ticket-today-table-parts {
  width: 100%;
  color: $black20;

  &__item {
    display: flex;
    gap: 8px;
    align-items: center;
    height: 20px;
    margin-top: 8px;
    font-size: 12px;
    border-bottom: 1px solid $black10;

    &-name {
      overflow: hidden;
      flex-grow: 1;
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &-count {
      flex-shrink: 0;
      text-align: left;
    }
  }
}
</style>
